/**
 * Deleting the last stage while people are in it would strand them: the stage would go, their
 * membership would still name it, and no board would show them again.
 */
export function deleteBlockedMessage(name: string, members: number): string {
  return `Add another stage first, so the ${members} ${members === 1 ? `person` : `people`} in ${name} have somewhere to go.`
}
